import { render, staticRenderFns } from "./lang-switcher.vue?vue&type=template&id=5f6a4f74"
import script from "./lang-switcher.vue?vue&type=script&lang=js"
export * from "./lang-switcher.vue?vue&type=script&lang=js"
import style0 from "./lang-switcher.vue?vue&type=style&index=0&id=5f6a4f74&prod&module=true&lang=sass"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports